
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3A4249","d":"M53.428 51.133l-1.81-1.045A5.956 5.956 0 0052 48c0-.736-.139-1.438-.382-2.089l1.809-1.045.5.867 1.732-1-2-3.465-1.732 1 .5.866-1.805 1.042A5.99 5.99 0 0047 42.09v-2.091h1v-2h-4v2h1v2.091a5.994 5.994 0 00-3.623 2.086l-1.805-1.042.5-.866-1.732-1-2 3.465 1.732 1 .5-.866 1.809 1.045A5.97 5.97 0 0040 48c0 .736.139 1.437.381 2.089l-1.809 1.044-.5-.866-1.732 1 2 3.465 1.732-1-.5-.866 1.805-1.042A5.99 5.99 0 0045 53.91V56h-1v2h4v-2h-1v-2.09a5.994 5.994 0 003.623-2.086l1.805 1.042-.5.867 1.732 1 2-3.465-1.732-1-.5.865zM46 51.999a4 4 0 11.001-8.001A4 4 0 0146 51.999zm-22-42c-3.859 0-7 3.141-7 7v4h14v-4c0-3.859-3.141-7-7-7zm-1 5.414l-1.293 1.293-1.414-1.414.707-.707v-1.586h2v2.414zm3.293 1.293L25 15.413v-2.414h2v1.586l.707.707-1.414 1.414z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M49.508 34.46L53 17 46 2h-7.793l6.883 14.749-3.601 18.007c-.777.265-1.527.587-2.235.977L43 17 36 2H12L5 17l9 45h20l1.057-5.283a13.96 13.96 0 001.688 1.767l-.001-.001L36.04 62H44l.031-.154-.017-.003c.65.092 1.31.157 1.986.157 7.732 0 14-6.268 14-14 0-6.519-4.461-11.981-10.492-13.54zM18 57.999h-2v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-28h-8c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2h2c0 2.206-1.794 4-4 4zm5-7h-2v2h-2v-2h-2v2h-2v-2h-2v2h-2v-2h-2v2h-2v-2h-2v-6c0-4.963 4.037-9 9-9s9 4.037 9 9v6zM46 60c-6.627 0-12-5.373-12-12s5.373-12 12-12 12 5.373 12 12-5.373 12-12 12z"}})])
          )
        }
      }
    